var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center appcontainer"},[_c('h1',{staticClass:"display-2",staticStyle:{"margin-top":"10%","color":"deeppink"}},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),(_vm.loginRequired)?_c('v-btn',{attrs:{"large":"","color":"info"},on:{"click":_vm.login}},[_vm._v(" Login ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb8d4fde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 97
// module chunks = 1